import './style.less';
import { orderBy } from 'lodash';

export default function ($log, CoursesClass, $stateParams, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  function activate() {
    $log.debug('Latest Course Activity Component Activated');
    vm.loaded = false;
    vm.error = {};
    vm.profileUid = $stateParams.id;
    vm.lastUpdatedCourse = {};
    vm.show = 5;

    ApiClass.coursesGet(
      { courseType: false },
      {},
      {
        queryParams: {
          internal: true,
          vendor: true,
          filters: JSON.stringify({ requireProgress: true, deliveryMethods: CoursesClass.delivery_methods, includeExpired: true })
        }
      }
    )
      .then(({ data: { courses = [] } }) => {
        $log.debug('Latest Course Activity Data:', courses);
        if (!courses || !courses.length) return (vm.loaded = true);

        vm.courses = orderBy(courses.filter(({ progress }) => !progress.cert), ['progress.updated_at'], ['desc']);
        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/latestCourseActivity/controller.js